import * as React from "react"
const SvgEkoIllusDunk1 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 1163 820"
    }}
    viewBox="0 0 1163 820"
    {...props}>
    <style>
      {
        ".ps_st2,.ps_st29{stroke:#2d0e5e;stroke-linejoin:round}.ps_st2{fill:none;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10}.ps_st29{fill:#ed4848;stroke-width:2}.ps_st29,.ps_st30,.ps_st34,.ps_st35{stroke-linecap:round;stroke-miterlimit:10}.ps_st30{fill:none;stroke:#2d0e5e;stroke-width:2}.ps_st34,.ps_st35{stroke:#111616;stroke-linejoin:round}.ps_st34{fill:none;stroke-width:1.5}.ps_st35{fill:#111616}.ps_st36{display:none}.ps_st38{display:inline}.ps_st39{fill:#e0d5b5;stroke:#5b480e;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ps_st53{fill:#4d4d4d}.ps_st54,.ps_st55{fill:#2e2e8b;stroke:#2e2e8b;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ps_st55{fill:none;stroke:#4d4d4d}.ps_st61,.ps_st62{display:inline;fill:#ddf2ee}.ps_st62{fill:#fff}.ps_st71{fill:#a6ac5d}.ps_st72{fill:#c5df8d}.ps_st100,.ps_st97,.ps_st98,.ps_st99{fill:#a7c4db;stroke:#a7c4db;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ps_st100,.ps_st98,.ps_st99{fill:#072e44;stroke:#072e44}.ps_st100,.ps_st99{fill:#13496d;stroke:#13496d}.ps_st100{fill:none}.ps_st101{fill:#13496d}.ps_st102{fill:#c2e6f5;stroke:#c2e6f5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ps_st108{fill:#477c4e}.ps_st123{fill:#ccb99a}.ps_st124{fill:#a58265}.ps_st126{fill:#845550}.ps_st127{fill:#26662c}.ps_st129{fill:#6c5410}.ps_st130{fill:#7ab929}.ps_st131{fill:#efb76b}.ps_st132{fill:#b8753a}.ps_st134{fill:#d4c0a0}"
      }
    </style>
    <g id="ps_Lager_1">
      <path
        d="M781.5 500.2C776 478.1 739.8 455.3 641 461c-70.2 4-128.1 33.4-129.8 53.8-.3 4 1.5 7.8 5.2 11.3-.9.1-1.7.2-2.6.3l-14.5-12c3.6-3 5.6-6.1 5.9-9.2 1.3-13.3-31-21.9-71.9-19.6-40.6 2.3-76.8 14.6-81 28-4.4 13.9 27.1 23.8 70.8 21.5.9 0 1.8-.1 2.6-.2.7 0 1.4-.1 2.1-.1 27.8-1.5 11.7 7.4 2.3 11.8-18.1 7.6-29.8 16.4-32 25.6-4.3 18.7 32.3 33.6 89.7 38.3 7 1.5 2 4.5.1 5.5l-.6.3c-8.7 4.2-14 9-14.6 14.1-1.7 14 34.4 24.1 80.9 22 46.8-2.1 83.9-15.6 82.7-29.6-.4-4.2-4.1-8-10.5-11.1-.5-.3-1.1-.6-1.9-.9-.4-.2-.8-.3-1.2-.5-7.5-3.4-1.3-6.2 4.9-7.9 2.9-.6 5.7-1.2 8.4-1.8 48.9-10.8 79.5-27.7 76.1-44.4-.6-2.9-2.1-5.6-4.5-8.2-.3-.4-.7-.7-1.1-1.1-1.4-1.7-2.6-4.9 5.7-6.8 45.9-9 73.1-24.2 69.3-39.9z"
        style={{
          opacity: 0.7,
          fill: "#e0d2fc"
        }}
      />
      <path
        d="m684.5 210.9-8.9-4.3c-10.3-5-22.2-5.1-32.6-.4l-77.8 38.5c-5.2 2.4-10.1 10.4-13.4 18.8L524.7 279c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4l-26.3 15c-11.9 6.8-19.3 19.5-19.3 33.2v173.4c0 16.5 8.8 31.7 23.1 39.9l34.3 19.6c14.1 8.1 31.4 8.1 45.6 0l128.3-72.9c23.1-14.1 23.1-25.4 23.1-41.9V242.4c.1-13.7-7.3-25.7-19.2-31.5z"
        style={{
          fill: "#e4e4ef"
        }}
      />
      <path
        d="m524.8 278.9 27-15.5"
        style={{
          fill: "none",
          stroke: "#2d0e5e",
          strokeWidth: 4,
          strokeMiterlimit: 10
        }}
      />
      <path
        d="m551.8 263.4-27.1 15.5c-1.8-.2-3.7-.3-5.7-.3-13.3 0-24.1 4.9-24.1 10.9v6.4"
        className="ps_st2"
      />
      <path
        d="m672.4 257.8-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        style={{
          opacity: 0.2,
          fill: "#2d0e5e"
        }}
      />
      <path
        d="m618.3 346.9-72.9 97.6 72.9 57.3 72.9-98.2z"
        style={{
          opacity: 0.4,
          fill: "#fff"
        }}
      />
      <path
        d="M547.6 280.7c.7-11.2 8.6-32 17.6-36.1l77.8-38.5c10.4-4.7 22.3-4.6 32.6.4l8.9 4.3c11.9 5.8 19.3 17.8 19.3 31.6v219.9c0 16.5 0 27.8-23.1 41.9l-128.3 72.9c-14.1 8-31.4 8-45.6 0l-34.3-19.6c-14.3-8.2-23.1-23.4-23.1-39.9V344.2c0-13.7 7.4-26.4 19.3-33.2l26.3-15"
        className="ps_st2"
      />
      <path
        d="m672.4 257.8-80.9 40.9c-8.4 4.2-15.2-.7-15.1-10.7 0-9.9 6.6-20.9 14.7-24.8l75.4-37c7.5-3.6 17-.8 18 8.1 1 9 1.6 15.4-12.1 23.5z"
        style={{
          fill: "none",
          stroke: "#2d0e5e",
          strokeWidth: 2,
          strokeMiterlimit: 10
        }}
      />
      <path
        d="M495 309.5c-2.8 1.2-4.4 2.6-4.4 4.1v15c0 7.1 12.8 12.9 28.5 12.9 15.8 0 28.5-5.8 28.5-12.9v-15c0-1.5-1.6-2.9-4.4-4.1"
        className="ps_st29"
      />
      <path
        d="M497.4 324.7c5.2 2.8 13 4.5 21.7 4.5 15.8 0 28.5-5.8 28.5-12.9"
        className="ps_st30"
      />
      <path
        d="M539 571.7c-9.5 3.5-9.5-3.4-9.5-3.4V383.4c0-13.7 7.4-26.4 19.3-33.2l15.4-9.3 121.9-62"
        style={{
          fill: "none",
          stroke: "#2d0e5e",
          strokeWidth: 2,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 10
        }}
      />
      <path
        d="m619.4 355.4 63.4 49.3-65.7 88.5-63.4-49.9 65.7-87.9m-1.1-8.5-72.9 97.5 72.9 57.3 72.9-98.2-72.9-56.6z"
        style={{
          fill: "#111616"
        }}
      />
      <path
        d="M592.3 457.3s6.8-5.7 8-7c1.1-1.3 3-3.8 3-3.8v-22.3s-.7-3.1-5.1-3.3c-4.5-.2-4.7.1-5.6.6-1 .5-3 2.5-3.2 2.6s-1.5-.6-1.4-.8c.1-.2 1.8-2.7 5.5-4.6 3.7-1.9 6.5-.6 7.1-.6.7 0 1.7.3 2.1-.2.4-.5-.2-4.1-1.3-5.3-1.1-1.2-5.5-2.4-6.6-3.3-1.1-.8-2.9-1.4-3.7-1.4s-1.5-.4-1.5-.7c0-.2.7-1.1.9-1.2.2-.1 3.4.2 3.9.6.5.3 2.4 1.6 3.7 1.5 1.3-.1 2.2-.1 2.4-.4.2-.3-.1-6.7-1.1-8.8-1-2.1-2.7-4.1-3.6-4.4-.9-.3-1.1-1-.9-1.3.2-.3.7-1 .7-1.1s.5 0 .7.2c.2.3 1.9 1.3 2.6 1.6.6.3 1.6 1.6 2.1 2.6.5.9.5 1.6.8 1.5.3-.1 1-3.5 1.1-4.1.1-.7.4-2.5.7-2.9.4-.3.5-.5.7-.8.1-.2.4.3.4 1.6s-1.3 6.9-1.2 7.2c.1.3 1.4 8.7 2.2 10.3.8 1.7 1.2 3.9 1.3 4.5.2.6.9 2.2 1.6 1.8s2.7-5.2 3.2-6.2 1.9-3.2 1.6-5.3-.5-11.8-.8-12.7-.6-3.7-.5-4c.1-.3 1-.8 1.3-1s.8 0 .9.7c.1.6.9 5.9.8 7.5 0 1.6.1 3.2.3 3 .2-.2 3.1-4.5 3.4-5.2.3-.7 3-5.6 3.3-6.7.3-1.1 1.3-3.3 1.5-3.5.2-.2 1.1-.3 1.1.3s-1 3.3-1.5 4.4c-.5 1.1-1.8 4.1-2.3 5s-2.4 3.7-3 4.6c-.6.8-1.8 2.9-1.8 2.9s.4 4.7.1 6.1c-.2 1.4-1.5 5.1-2 6.2s-.9 2.6-.7 2.5c.2-.1 3.2-5 4.1-5.7.9-.7 5-2.2 6.2-3.7 1.2-1.5 5-7.6 5.4-8.5.4-1 2.3-4 2.5-4.4.3-.4.5.1.6.2s-.8 2.8-1 3.6c-.2.8-3.9 8-4.4 8.7s-1.5 2.5-2.8 3.3c-1.3.8-3.5 2-4.5 3.7-1.1 1.8-6.3 9.8-6.3 10s.1 15.7.2 16 5.3 1.6 9.6 1.1c0 0-.1.3-.3.5-.3.2-4 1.7-5.2 1.9s-2.8.8-3.5 1.2c-.7.4-2.6 1.5-3.6 4.4-1 2.9-1.9 5.6-2.1 5.8-.2.2-.9-1.3-1.1-1.8-.2-.5-1.7-1.4-3.1-.6-1.4.9-3.4 1.8-4.1 2.5s-1.7 1.7-2.8 2.2c-.6.4-3.3 2.3-5 2.7z"
        style={{
          fill: "#111616",
          stroke: "#111616",
          strokeWidth: 1.5,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeMiterlimit: 10
        }}
      />
      <path
        d="M628.5 446.8s8.4-11.3 16.4-20.3c8-9 12.9-13.1 14.8-10.6 1.9 2.5-3.7 10.7-7.5 13.9-3.8 3.2-17.1 13.7-23.7 17z"
        className="ps_st34"
      />
      <path
        d="M658.2 422.4c.7 0 1.2.3 1.6.8 1.9 2.5-4.2 10.1-8.3 12.9-3.1 2.2-12.3 8.3-19.5 12.3M633 440.8s.1-4.2-4.8-3.3c-4.9.8-7.3 6.3-7.6 7.2-.3.9-1.7 5.1-1.8 6.1"
        className="ps_st34"
      />
      <path
        d="M620.7 450.6s-3.3.6-5.3 1.8-5.2 2.5-5.7 2.5c0 0 1.1.9 1.6.9s1.5 2.1 1.7 2.7 3.7 5.1 7.1 2.6 3.5-6 3.5-6 4.4-1.6 6.7-4.2 2.8-5.3 2.9-7"
        className="ps_st34"
      />
      <path
        d="m615.6 458.7-3.6 1.4-6.2-3.1M615.1 460.8l-2.2 2.5s-5.5-1.7-6.8-2M621.9 445.2s-4.5 1.4-5.3.3c-.8-1.1-1.3-4.9-1.3-4.9M619.1 449.4s-3.5-.1-4.2-.5c-.7-.4-2.1-2.3-2.1-2.3M626.4 440.9s-.2-8.3-.8-9.1c-.6-.9-3.8-2.3-3.8-2.3M633 430.1s-.6-12.2-1.3-13.1c-.7-.8-2.8-3.3-2.8-3.3"
        className="ps_st34"
      />
      <path
        d="M627.7 437.6s3.3-7.5 4.1-10.2 2-7.6 4.2-11.3c2.3-3.7 5-8.6 5-8.6"
        className="ps_st34"
      />
      <path
        d="M640.7 407s4.2 2.1 5.2 4.9c1 2.7 2 9.9-2 15.6"
        className="ps_st34"
      />
      <path
        d="M642.8 428.8s-1-7.1-10.7-2.4l2-6.3c9.2-5.2 12.4.8 12.4.8l-.8 3.2-2.9 4.7zM646.1 412.5s-4.2-3.1-8.1.4l2.9-5 .9-.2 2.3 1.7 1.3 1.4.7 1.7z"
        className="ps_st35"
      />
      <path
        d="M630.9 429.9s-1.7-6.9-2.1-7.5c-.4-.5-2.9-2.5-2.9-2.5M623.1 440.6s-.5-3.7-1.2-4.2-3-1.4-3-1.4"
        className="ps_st34"
      />
      <path
        d="M617 455.2s4.5-2.1 3.4 1.1c-1.1 3.1-3.4-1.1-3.4-1.1zM629.2 434s6.1-1.6 7.9 1.6l-3.9 4.6-1.3-2.1-1.4-.7h-1.8l-.5-.8 1-2.6z"
        className="ps_st35"
      />
      <path
        d="M502 297.2c4.4 2 10.4 3.2 17 3.2 13.3 0 24.1-4.9 24.1-10.9s-10.8-10.9-24.1-10.9-24.1 4.9-24.1 10.9v20.7c0 6 10.8 10.9 24.1 10.9s24.1-4.9 24.1-10.9v-20.7"
        className="ps_st29"
      />
      <path
        d="M511.6 306.7v13.8M521.5 308.1v12.4M529.6 306.7V320M537 304.1v13.4"
        className="ps_st30"
      />
    </g>
  </svg>
)
export default SvgEkoIllusDunk1
